import { useState, useContext } from 'react';
import '../../../styles/Login.css'
import { USERURL, CDASHBOARD } from "../config/config";
import { toast } from "react-toastify";
import { useDispatch } from 'react-redux';
import { login } from '../../../slice/authSlice';

export const Login = () => {

  const dispatch = useDispatch();

  const [inputFields, setInputFields] = useState({
    'username': '',
    'password': ''
  })

  const [errors, setErrors] = useState({
    'username': '',
    'password': '',
    'finalmessage': ''
  })

  const validate = () => {
    const newErrors = {}

    let emailtest = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let passtest = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[#!$@])[a-zA-Z0-9#!$@]{8,}$/;

    if (inputFields.username === '') newErrors.username = 'Enter email'
    else if (!emailtest.test(inputFields.username)) newErrors.email = 'Enter email not in format'

    if (inputFields.password === '') newErrors.password = 'Enter password'
    else if (!passtest.test(inputFields.password)) newErrors.password = 'Enter password not in format';

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0;
  }

  const handleChange = (e) => {

    const { name, value } = e.target;
    setInputFields({ ...inputFields, [name]: value })
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    const isValid = validate();
    if (isValid) {
      try {
        const datastring = {
          'username': inputFields.username,
          'password': inputFields.password
        };
        const api = `${USERURL}login`;
        const postData = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(datastring)
        };

        const response = await fetch(api, postData);
        const res = await response.json();

        if (res.actionMsg === 0 && Array.isArray(res.errors)) {
          res.errors.forEach((item) => {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [item.path]: item.message
            }));
          });
        } else if (res.actionMsg === 0) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            finalmessage: res.Message
          }));
        } else {
          const token = res?.access_token?.split(' ')[1];
          const userDetails = res?.userDetails;

          let payload = {
            'userdetails': userDetails,
            'access_token': token,
            'candidate_id': userDetails?.candidate_id
          }
          dispatch(login(payload))
          window.location.href = "/panel"
        }
      } catch (error) {
        const message = error.message || 'Contact admin';
        toast.error(message, { duration: 2000 });
      }
    }
  };

  return (
    <>
      <title>Ampstek Candidate Login Page</title>
      <div className="login-container">
      <div className='app-logo'>
        <img className='logo' src="https://www.ampstek.com/assets/img/logo6.png" alt='Ampstek'/>
      </div>
      <form onSubmit={handleSubmit} className="login-form">

        <h2>Login</h2>
        {errors && <p className="error">{errors.finalmessage}</p>}
        <div className="form-group">
          <label htmlFor="username">Email</label>
          <input
            type="text"
            id="username"
            name='username'
            onChange={handleChange}
            value={inputFields.username}
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            onChange={handleChange}
            value={inputFields.password}
          />
        </div>
        <button type="submit" className="login-btn">
          Login
        </button>
      </form>
    </div>
    </>
    
  );
};